//////////////////////////////////////////////////////////////////////////////////////////////
// DO NOT MODIFY THIS FILE                                                                  //
// This file is automatically generated by ZenStack CLI and should not be manually updated. //
//////////////////////////////////////////////////////////////////////////////////////////////

/* eslint-disable */

import { type SchemaDef, type AttributeApplication, type FieldDefault, ExpressionUtils } from "@zenstackhq/schema";
export class SchemaType implements SchemaDef {
    provider = {
        type: "postgresql"
    } as const;
    models = {
        User: {
            name: "User",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                email: {
                    name: "email",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                password: {
                    name: "password",
                    type: "String",
                    omit: true,
                    attributes: [{ name: "@omit" }] as readonly AttributeApplication[]
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("USER") }] }, { name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")) }] }] as readonly AttributeApplication[],
                    default: "USER" as FieldDefault
                },
                approved: {
                    name: "approved",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }, { name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("SUPERDOC"))) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                notificationsEnabled: {
                    name: "notificationsEnabled",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                notificationsSeenAt: {
                    name: "notificationsSeenAt",
                    type: "DateTime",
                    optional: true
                },
                deactivatedAt: {
                    name: "deactivatedAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                specialist: {
                    name: "specialist",
                    type: "Specialist",
                    optional: true,
                    relation: { opposite: "user" }
                },
                invitesSent: {
                    name: "invitesSent",
                    type: "Invite",
                    array: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("invitedBy") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "invitedBy", name: "invitedBy" }
                },
                authoredNotes: {
                    name: "authoredNotes",
                    type: "Note",
                    array: true,
                    relation: { opposite: "author" }
                },
                createdGroupEvents: {
                    name: "createdGroupEvents",
                    type: "GroupEvent",
                    array: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("GroupEventCreator") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "createdBy", name: "GroupEventCreator" }
                },
                groupEventMemberships: {
                    name: "groupEventMemberships",
                    type: "GroupEventMember",
                    array: true,
                    relation: { opposite: "user" }
                },
                assignedEnrollments: {
                    name: "assignedEnrollments",
                    type: "GroupEventEnrollment",
                    array: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("EnrollmentAssignee") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "assignedUser", name: "EnrollmentAssignee" }
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("id")))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC")), "&&", ExpressionUtils.binary(ExpressionUtils.field("role"), "!=", ExpressionUtils.literal("ADMIN")))), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("id")))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC")), "&&", ExpressionUtils.binary(ExpressionUtils.field("role"), "!=", ExpressionUtils.literal("ADMIN")))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                email: { type: "String" }
            }
        },
        Specialty: {
            name: "Specialty",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }, { name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("SUPERDOC"))) }] }] as readonly AttributeApplication[]
                },
                name: {
                    name: "name",
                    type: "Json",
                    attributes: [{ name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("SUPERDOC"))) }] }] as readonly AttributeApplication[]
                },
                aliases: {
                    name: "aliases",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }, { name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("SUPERDOC"))) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }, { name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("SUPERDOC"))) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                specialists: {
                    name: "specialists",
                    type: "Specialist",
                    array: true,
                    relation: { opposite: "specialties" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.call("auth"), "!=", ExpressionUtils._null()) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        Service: {
            name: "Service",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }, { name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("SUPERDOC"))) }] }] as readonly AttributeApplication[]
                },
                name: {
                    name: "name",
                    type: "Json",
                    attributes: [{ name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("SUPERDOC"))) }] }] as readonly AttributeApplication[]
                },
                aliases: {
                    name: "aliases",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }, { name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("SUPERDOC"))) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                color: {
                    name: "color",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("SUPERDOC"))) }] }] as readonly AttributeApplication[]
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }, { name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("SUPERDOC"))) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                enrollments: {
                    name: "enrollments",
                    type: "GroupEventEnrollment",
                    array: true,
                    relation: { opposite: "service" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.call("auth"), "!=", ExpressionUtils._null()) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        ClinicSettings: {
            name: "ClinicSettings",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("singleton") }] }] as readonly AttributeApplication[],
                    default: "singleton" as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                logo: {
                    name: "logo",
                    type: "String",
                    optional: true
                },
                phone: {
                    name: "phone",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.call("auth"), "!=", ExpressionUtils._null()) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Specialist: {
            name: "Specialist",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                userId: {
                    name: "userId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("userId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "specialist", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                displayName: {
                    name: "displayName",
                    type: "Json",
                    optional: true
                },
                title: {
                    name: "title",
                    type: "Json",
                    optional: true
                },
                bio: {
                    name: "bio",
                    type: "Json",
                    optional: true
                },
                phone: {
                    name: "phone",
                    type: "String",
                    optional: true
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                specialties: {
                    name: "specialties",
                    type: "Specialty",
                    array: true,
                    relation: { opposite: "specialists" }
                },
                availabilitySources: {
                    name: "availabilitySources",
                    type: "AvailabilitySource",
                    array: true,
                    relation: { opposite: "specialist" }
                },
                healeeConnection: {
                    name: "healeeConnection",
                    type: "HealeeConnection",
                    optional: true,
                    relation: { opposite: "specialist" }
                },
                appointments: {
                    name: "appointments",
                    type: "Appointment",
                    array: true,
                    relation: { opposite: "specialist" }
                },
                calls: {
                    name: "calls",
                    type: "Call",
                    array: true,
                    relation: { opposite: "specialist" }
                },
                assignedContacts: {
                    name: "assignedContacts",
                    type: "Contact",
                    array: true,
                    relation: { opposite: "assignedSpecialists" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SPECIALIST")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("userId")))), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("user"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SPECIALIST")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("userId")))), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("user"), ["role"]), "!=", ExpressionUtils.literal("ADMIN")))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                userId: { type: "String" }
            }
        },
        AvailabilitySource: {
            name: "AvailabilitySource",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    foreignKeyFor: [
                        "specialist"
                    ] as readonly string[]
                },
                specialist: {
                    name: "specialist",
                    type: "Specialist",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("specialistId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "availabilitySources", fields: ["specialistId"], references: ["id"], onDelete: "Cascade" }
                },
                provider: {
                    name: "provider",
                    type: "AvailabilityProvider"
                },
                config: {
                    name: "config",
                    type: "Json"
                },
                eventId: {
                    name: "eventId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "event"
                    ] as readonly string[]
                },
                event: {
                    name: "event",
                    type: "GroupEvent",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("GroupEventSources") }, { name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("eventId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "availabilitySources", name: "GroupEventSources", fields: ["eventId"], references: ["id"], onDelete: "SetNull" }
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                priority: {
                    name: "priority",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("specialistId"), ExpressionUtils.field("provider")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("specialistId"), ExpressionUtils.field("active")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("eventId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create,update,delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SPECIALIST")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("specialist"), ["userId"]), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]))), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("specialist"), ["user", "role"]), "!=", ExpressionUtils.literal("ADMIN")))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                specialistId_provider: { specialistId: { type: "String" }, provider: { type: "AvailabilityProvider" } }
            }
        },
        HealeeConnection: {
            name: "HealeeConnection",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "specialist"
                    ] as readonly string[]
                },
                specialist: {
                    name: "specialist",
                    type: "Specialist",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("specialistId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "healeeConnection", fields: ["specialistId"], references: ["id"], onDelete: "Cascade" }
                },
                calendarId: {
                    name: "calendarId",
                    type: "Int"
                },
                settings: {
                    name: "settings",
                    type: "Json",
                    optional: true
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                connectedAt: {
                    name: "connectedAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("Int", [ExpressionUtils.field("calendarId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                specialistId: { type: "String" }
            }
        },
        Appointment: {
            name: "Appointment",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    foreignKeyFor: [
                        "specialist"
                    ] as readonly string[]
                },
                specialist: {
                    name: "specialist",
                    type: "Specialist",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("specialistId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "appointments", fields: ["specialistId"], references: ["id"], onDelete: "Cascade" }
                },
                patientName: {
                    name: "patientName",
                    type: "String"
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String"
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                extraPatients: {
                    name: "extraPatients",
                    type: "Json",
                    optional: true
                },
                startsAt: {
                    name: "startsAt",
                    type: "DateTime"
                },
                endsAt: {
                    name: "endsAt",
                    type: "DateTime"
                },
                googleEventId: {
                    name: "googleEventId",
                    type: "String",
                    optional: true
                },
                healeeAppointmentId: {
                    name: "healeeAppointmentId",
                    type: "Int",
                    unique: true,
                    optional: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                conversationId: {
                    name: "conversationId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("conversationId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("conversationId")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "appointments", fields: ["conversationId"], references: ["conversationId"], onDelete: "SetNull" }
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "contact"
                    ] as readonly string[]
                },
                contact: {
                    name: "contact",
                    type: "Contact",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("contactId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "appointments", fields: ["contactId"], references: ["id"], onDelete: "SetNull" }
                },
                notes: {
                    name: "notes",
                    type: "Note",
                    array: true,
                    relation: { opposite: "appointment" }
                },
                status: {
                    name: "status",
                    type: "AppointmentStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("BOOKED") }] }] as readonly AttributeApplication[],
                    default: "BOOKED" as FieldDefault
                },
                rescheduled: {
                    name: "rescheduled",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                calendarDesynced: {
                    name: "calendarDesynced",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                source: {
                    name: "source",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("voice") }] }] as readonly AttributeApplication[],
                    default: "voice" as FieldDefault
                },
                slotSeq: {
                    name: "slotSeq",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                healee: {
                    name: "healee",
                    type: "AppointmentHealee",
                    optional: true,
                    relation: { opposite: "appointment" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("specialistId"), ExpressionUtils.field("startsAt")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("patientPhone")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("contactId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("conversationId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SPECIALIST")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("specialist"), ["userId"]), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create,delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC")), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SPECIALIST")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("specialist"), ["userId"]), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                healeeAppointmentId: { type: "Int" }
            }
        },
        AppointmentHealee: {
            name: "AppointmentHealee",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                appointmentId: {
                    name: "appointmentId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "appointment"
                    ] as readonly string[]
                },
                appointment: {
                    name: "appointment",
                    type: "Appointment",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("appointmentId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "healee", fields: ["appointmentId"], references: ["id"], onDelete: "Cascade" }
                },
                patientAge: {
                    name: "patientAge",
                    type: "Int",
                    optional: true
                },
                patientNote: {
                    name: "patientNote",
                    type: "String",
                    optional: true
                },
                isVideo: {
                    name: "isVideo",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                bookedOnline: {
                    name: "bookedOnline",
                    type: "Boolean",
                    optional: true
                },
                paymentMethodName: {
                    name: "paymentMethodName",
                    type: "String",
                    optional: true
                },
                insurerName: {
                    name: "insurerName",
                    type: "String",
                    optional: true
                },
                insurerStatus: {
                    name: "insurerStatus",
                    type: "String",
                    optional: true
                },
                meta: {
                    name: "meta",
                    type: "Json",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SPECIALIST")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("appointment"), ["specialist", "userId"]), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                appointmentId: { type: "String" }
            }
        },
        Call: {
            name: "Call",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                conversationId: {
                    name: "conversationId",
                    type: "String",
                    unique: true,
                    optional: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "specialist"
                    ] as readonly string[]
                },
                specialist: {
                    name: "specialist",
                    type: "Specialist",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("specialistId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "calls", fields: ["specialistId"], references: ["id"], onDelete: "SetNull" }
                },
                booked: {
                    name: "booked",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                bookingAction: {
                    name: "bookingAction",
                    type: "CallBookingAction",
                    optional: true
                },
                bookingLabel: {
                    name: "bookingLabel",
                    type: "String",
                    optional: true
                },
                callerName: {
                    name: "callerName",
                    type: "String",
                    optional: true
                },
                callerPhone: {
                    name: "callerPhone",
                    type: "String",
                    optional: true
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "contact"
                    ] as readonly string[]
                },
                contact: {
                    name: "contact",
                    type: "Contact",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("contactId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "calls", fields: ["contactId"], references: ["id"], onDelete: "SetNull" }
                },
                assistantId: {
                    name: "assistantId",
                    type: "String",
                    optional: true
                },
                startedAt: {
                    name: "startedAt",
                    type: "DateTime",
                    optional: true
                },
                endedAt: {
                    name: "endedAt",
                    type: "DateTime",
                    optional: true
                },
                endedReason: {
                    name: "endedReason",
                    type: "String",
                    optional: true
                },
                durationSec: {
                    name: "durationSec",
                    type: "Int",
                    optional: true
                },
                cost: {
                    name: "cost",
                    type: "Float",
                    optional: true
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true
                },
                transcript: {
                    name: "transcript",
                    type: "CallTranscript",
                    optional: true,
                    relation: { opposite: "call" }
                },
                appointments: {
                    name: "appointments",
                    type: "Appointment",
                    array: true,
                    relation: { opposite: "call" }
                },
                groupEnrollments: {
                    name: "groupEnrollments",
                    type: "GroupEventEnrollment",
                    array: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("CallEnrollments") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "call", name: "CallEnrollments" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("specialistId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("callerPhone")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("contactId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SPECIALIST")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("specialist"), ["userId"]), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                conversationId: { type: "String" }
            }
        },
        CallTranscript: {
            name: "CallTranscript",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("callId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "transcript", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                text: {
                    name: "text",
                    type: "String",
                    optional: true
                },
                messages: {
                    name: "messages",
                    type: "Json",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))), "||", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SPECIALIST")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("call"), ["specialist", "userId"]), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId: { type: "String" }
            }
        },
        ActivityEvent: {
            name: "ActivityEvent",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                action: {
                    name: "action",
                    type: "ActivityAction"
                },
                platform: {
                    name: "platform",
                    type: "ActivityPlatform"
                },
                domain: {
                    name: "domain",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("calendar") }] }] as readonly AttributeApplication[],
                    default: "calendar" as FieldDefault
                },
                actorUserId: {
                    name: "actorUserId",
                    type: "String",
                    optional: true
                },
                actorName: {
                    name: "actorName",
                    type: "String",
                    optional: true
                },
                appointmentId: {
                    name: "appointmentId",
                    type: "String",
                    optional: true
                },
                enrollmentId: {
                    name: "enrollmentId",
                    type: "String",
                    optional: true
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    optional: true
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true
                },
                conversationId: {
                    name: "conversationId",
                    type: "String",
                    optional: true
                },
                externalRef: {
                    name: "externalRef",
                    type: "String",
                    optional: true
                },
                doctorName: {
                    name: "doctorName",
                    type: "String",
                    optional: true
                },
                patientName: {
                    name: "patientName",
                    type: "String",
                    optional: true
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String",
                    optional: true
                },
                whenText: {
                    name: "whenText",
                    type: "String",
                    optional: true
                },
                oldWhenText: {
                    name: "oldWhenText",
                    type: "String",
                    optional: true
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                note: {
                    name: "note",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("DateTime", [ExpressionUtils.field("createdAt")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("ActivityAction", [ExpressionUtils.field("action")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("ActivityPlatform", [ExpressionUtils.field("platform")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Contact: {
            name: "Contact",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String"
                },
                phone: {
                    name: "phone",
                    type: "String"
                },
                altPhones: {
                    name: "altPhones",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                status: {
                    name: "status",
                    type: "ContactStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("LEAD") }] }] as readonly AttributeApplication[],
                    default: "LEAD" as FieldDefault
                },
                flags: {
                    name: "flags",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                assignedSpecialists: {
                    name: "assignedSpecialists",
                    type: "Specialist",
                    array: true,
                    relation: { opposite: "assignedContacts" }
                },
                notes: {
                    name: "notes",
                    type: "Note",
                    array: true,
                    relation: { opposite: "contact" }
                },
                calls: {
                    name: "calls",
                    type: "Call",
                    array: true,
                    relation: { opposite: "contact" }
                },
                appointments: {
                    name: "appointments",
                    type: "Appointment",
                    array: true,
                    relation: { opposite: "contact" }
                },
                groupEnrollments: {
                    name: "groupEnrollments",
                    type: "GroupEventEnrollment",
                    array: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("ContactEnrollments") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "contact", name: "ContactEnrollments" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("name"), ExpressionUtils.field("phone")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("phone")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create,update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SPECIALIST"))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                name_phone: { name: { type: "String" }, phone: { type: "String" } }
            }
        },
        Note: {
            name: "Note",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    foreignKeyFor: [
                        "contact"
                    ] as readonly string[]
                },
                contact: {
                    name: "contact",
                    type: "Contact",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("contactId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "notes", fields: ["contactId"], references: ["id"], onDelete: "Cascade" }
                },
                appointmentId: {
                    name: "appointmentId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "appointment"
                    ] as readonly string[]
                },
                appointment: {
                    name: "appointment",
                    type: "Appointment",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("appointmentId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "notes", fields: ["appointmentId"], references: ["id"], onDelete: "Cascade" }
                },
                body: {
                    name: "body",
                    type: "String"
                },
                authorId: {
                    name: "authorId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "author"
                    ] as readonly string[]
                },
                author: {
                    name: "author",
                    type: "User",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("authorId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "authoredNotes", fields: ["authorId"], references: ["id"], onDelete: "SetNull" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("contactId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("appointmentId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("authorId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SPECIALIST"))), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("authorId"))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("update,delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("authorId"))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Voice: {
            name: "Voice",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                label: {
                    name: "label",
                    type: "String"
                },
                voiceId: {
                    name: "voiceId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                language: {
                    name: "language",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                voiceId: { type: "String" }
            }
        },
        VoiceAgent: {
            name: "VoiceAgent",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String"
                },
                kind: {
                    name: "kind",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("assistant") }] }] as readonly AttributeApplication[],
                    default: "assistant" as FieldDefault
                },
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String",
                    unique: true,
                    optional: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                systemPrompt: {
                    name: "systemPrompt",
                    type: "String",
                    optional: true
                },
                config: {
                    name: "config",
                    type: "Json",
                    optional: true
                },
                kbDocumentId: {
                    name: "kbDocumentId",
                    type: "String",
                    optional: true
                },
                faq: {
                    name: "faq",
                    type: "String",
                    optional: true
                },
                faqDocumentId: {
                    name: "faqDocumentId",
                    type: "String",
                    optional: true
                },
                language: {
                    name: "language",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("bg") }] }] as readonly AttributeApplication[],
                    default: "bg" as FieldDefault
                },
                knowledgeDocs: {
                    name: "knowledgeDocs",
                    type: "AgentKnowledgeDoc",
                    array: true,
                    relation: { opposite: "agent" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                externalAgentId: { type: "String" }
            }
        },
        AgentKnowledgeDoc: {
            name: "AgentKnowledgeDoc",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                agent: {
                    name: "agent",
                    type: "VoiceAgent",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("agentId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "knowledgeDocs", fields: ["agentId"], references: ["id"], onDelete: "Cascade" }
                },
                agentId: {
                    name: "agentId",
                    type: "String",
                    foreignKeyFor: [
                        "agent"
                    ] as readonly string[]
                },
                title: {
                    name: "title",
                    type: "String"
                },
                text: {
                    name: "text",
                    type: "String"
                },
                documentId: {
                    name: "documentId",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        EmailDelivery: {
            name: "EmailDelivery",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                resendId: {
                    name: "resendId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                template: {
                    name: "template",
                    type: "String"
                },
                to: {
                    name: "to",
                    type: "String"
                },
                status: {
                    name: "status",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("sent") }] }] as readonly AttributeApplication[],
                    default: "sent" as FieldDefault
                },
                idempotencyKey: {
                    name: "idempotencyKey",
                    type: "String",
                    optional: true
                },
                lastEventAt: {
                    name: "lastEventAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                resendId: { type: "String" }
            }
        },
        GroupEvent: {
            name: "GroupEvent",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                name: {
                    name: "name",
                    type: "Json"
                },
                description: {
                    name: "description",
                    type: "Json",
                    optional: true
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                createdById: {
                    name: "createdById",
                    type: "String",
                    foreignKeyFor: [
                        "createdBy"
                    ] as readonly string[]
                },
                createdBy: {
                    name: "createdBy",
                    type: "User",
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("GroupEventCreator") }, { name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("createdById")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "createdGroupEvents", name: "GroupEventCreator", fields: ["createdById"], references: ["id"], onDelete: "Cascade" }
                },
                members: {
                    name: "members",
                    type: "GroupEventMember",
                    array: true,
                    relation: { opposite: "event" }
                },
                slots: {
                    name: "slots",
                    type: "GroupEventSlot",
                    array: true,
                    relation: { opposite: "event" }
                },
                availabilitySources: {
                    name: "availabilitySources",
                    type: "AvailabilitySource",
                    array: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("GroupEventSources") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "event", name: "GroupEventSources" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("createdById")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("SUPERDOC"))), "||", ExpressionUtils.binary(ExpressionUtils.field("createdById"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]))), "||", ExpressionUtils.binary(ExpressionUtils.field("members"), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.field("createdById"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]))), "||", ExpressionUtils.binary(ExpressionUtils.field("members"), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.field("createdById"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        GroupEventMember: {
            name: "GroupEventMember",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                eventId: {
                    name: "eventId",
                    type: "String",
                    foreignKeyFor: [
                        "event"
                    ] as readonly string[]
                },
                event: {
                    name: "event",
                    type: "GroupEvent",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("eventId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "members", fields: ["eventId"], references: ["id"], onDelete: "Cascade" }
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("userId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "groupEventMemberships", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("eventId"), ExpressionUtils.field("userId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("userId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("event"), ["createdById"]), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]))), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("event"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                eventId_userId: { eventId: { type: "String" }, userId: { type: "String" } }
            }
        },
        GroupEventSlot: {
            name: "GroupEventSlot",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                eventId: {
                    name: "eventId",
                    type: "String",
                    foreignKeyFor: [
                        "event"
                    ] as readonly string[]
                },
                event: {
                    name: "event",
                    type: "GroupEvent",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("eventId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "slots", fields: ["eventId"], references: ["id"], onDelete: "Cascade" }
                },
                startsAt: {
                    name: "startsAt",
                    type: "DateTime"
                },
                endsAt: {
                    name: "endsAt",
                    type: "DateTime"
                },
                capacity: {
                    name: "capacity",
                    type: "Int"
                },
                booked: {
                    name: "booked",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                closed: {
                    name: "closed",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                seriesId: {
                    name: "seriesId",
                    type: "String",
                    optional: true
                },
                enrollments: {
                    name: "enrollments",
                    type: "GroupEventEnrollment",
                    array: true,
                    relation: { opposite: "slot" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("eventId"), ExpressionUtils.field("startsAt")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("seriesId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("event"), ["createdById"]), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]))), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("event"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        GroupEventEnrollment: {
            name: "GroupEventEnrollment",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                slotId: {
                    name: "slotId",
                    type: "String",
                    foreignKeyFor: [
                        "slot"
                    ] as readonly string[]
                },
                slot: {
                    name: "slot",
                    type: "GroupEventSlot",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("slotId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "enrollments", fields: ["slotId"], references: ["id"], onDelete: "Cascade" }
                },
                patientName: {
                    name: "patientName",
                    type: "String"
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String"
                },
                assignedUserId: {
                    name: "assignedUserId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "assignedUser"
                    ] as readonly string[]
                },
                assignedUser: {
                    name: "assignedUser",
                    type: "User",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("EnrollmentAssignee") }, { name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("assignedUserId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "assignedEnrollments", name: "EnrollmentAssignee", fields: ["assignedUserId"], references: ["id"], onDelete: "SetNull" }
                },
                serviceId: {
                    name: "serviceId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "service"
                    ] as readonly string[]
                },
                service: {
                    name: "service",
                    type: "Service",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("serviceId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "enrollments", fields: ["serviceId"], references: ["id"], onDelete: "SetNull" }
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "contact"
                    ] as readonly string[]
                },
                contact: {
                    name: "contact",
                    type: "Contact",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("ContactEnrollments") }, { name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("contactId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "groupEnrollments", name: "ContactEnrollments", fields: ["contactId"], references: ["id"], onDelete: "SetNull" }
                },
                conversationId: {
                    name: "conversationId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("CallEnrollments") }, { name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("conversationId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("conversationId")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "groupEnrollments", name: "CallEnrollments", fields: ["conversationId"], references: ["conversationId"], onDelete: "SetNull" }
                },
                arrivalTime: {
                    name: "arrivalTime",
                    type: "String",
                    optional: true
                },
                status: {
                    name: "status",
                    type: "EnrollmentStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("ENROLLED") }] }] as readonly AttributeApplication[],
                    default: "ENROLLED" as FieldDefault
                },
                source: {
                    name: "source",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("voice") }] }] as readonly AttributeApplication[],
                    default: "voice" as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("slotId"), ExpressionUtils.field("patientPhone"), ExpressionUtils.field("patientName")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("patientPhone")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("contactId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("conversationId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("serviceId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("assignedUserId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("slot"), ["event", "createdById"]), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]))), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("slot"), ["event", "members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slotId_patientPhone_patientName: { slotId: { type: "String" }, patientPhone: { type: "String" }, patientName: { type: "String" } }
            }
        },
        Invite: {
            name: "Invite",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                token: {
                    name: "token",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                email: {
                    name: "email",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "Role",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("SPECIALIST") }] }] as readonly AttributeApplication[],
                    default: "SPECIALIST" as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime"
                },
                visitedAt: {
                    name: "visitedAt",
                    type: "DateTime",
                    optional: true
                },
                usedAt: {
                    name: "usedAt",
                    type: "DateTime",
                    optional: true
                },
                invitedById: {
                    name: "invitedById",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "invitedBy"
                    ] as readonly string[]
                },
                invitedBy: {
                    name: "invitedBy",
                    type: "User",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("invitedBy") }, { name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("invitedById")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "invitesSent", name: "invitedBy", fields: ["invitedById"], references: ["id"], onDelete: "SetNull" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("email"), ExpressionUtils.field("usedAt")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                token: { type: "String" }
            }
        }
    } as const;
    typeDefs = {
        Auth: {
            name: "Auth",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    attributes: [{ name: "@id" }] as readonly AttributeApplication[]
                },
                role: {
                    name: "role",
                    type: "Role"
                },
                approved: {
                    name: "approved",
                    type: "Boolean"
                }
            },
            attributes: [
                { name: "@@auth" }
            ] as readonly AttributeApplication[]
        },
        SignUpInput: {
            name: "SignUpInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        LoginInput: {
            name: "LoginInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                }
            }
        },
        AdminInviteUserInput: {
            name: "AdminInviteUserInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "Role",
                    optional: true
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        AdminCreateUserInput: {
            name: "AdminCreateUserInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role",
                    optional: true
                },
                approved: {
                    name: "approved",
                    type: "Boolean",
                    optional: true
                }
            }
        },
        AcceptInviteInput: {
            name: "AcceptInviteInput",
            fields: {
                token: {
                    name: "token",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        CheckInviteInput: {
            name: "CheckInviteInput",
            fields: {
                token: {
                    name: "token",
                    type: "String"
                }
            }
        },
        CheckInviteResult: {
            name: "CheckInviteResult",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role"
                }
            }
        },
        FindSpecialistsInput: {
            name: "FindSpecialistsInput",
            fields: {
                query: {
                    name: "query",
                    type: "String",
                    optional: true
                },
                specialtySlug: {
                    name: "specialtySlug",
                    type: "String",
                    optional: true
                },
                activeOnly: {
                    name: "activeOnly",
                    type: "Boolean",
                    optional: true
                }
            }
        },
        GoogleCalendarConnectInput: {
            name: "GoogleCalendarConnectInput",
            fields: {
                availabilitySourceId: {
                    name: "availabilitySourceId",
                    type: "String"
                }
            }
        },
        GoogleCalendarConnectResult: {
            name: "GoogleCalendarConnectResult",
            fields: {
                consentUrl: {
                    name: "consentUrl",
                    type: "String"
                }
            }
        },
        GoogleCalendarDisconnectInput: {
            name: "GoogleCalendarDisconnectInput",
            fields: {
                availabilitySourceId: {
                    name: "availabilitySourceId",
                    type: "String"
                }
            }
        },
        GoogleCalendarEventsInput: {
            name: "GoogleCalendarEventsInput",
            fields: {
                availabilitySourceId: {
                    name: "availabilitySourceId",
                    type: "String"
                },
                from: {
                    name: "from",
                    type: "String"
                },
                to: {
                    name: "to",
                    type: "String"
                }
            }
        },
        GoogleCalendarEvent: {
            name: "GoogleCalendarEvent",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true
                },
                location: {
                    name: "location",
                    type: "String",
                    optional: true
                },
                start: {
                    name: "start",
                    type: "String"
                },
                end: {
                    name: "end",
                    type: "String"
                },
                allDay: {
                    name: "allDay",
                    type: "Boolean"
                },
                status: {
                    name: "status",
                    type: "String",
                    optional: true
                },
                htmlLink: {
                    name: "htmlLink",
                    type: "String",
                    optional: true
                },
                extraCount: {
                    name: "extraCount",
                    type: "Int",
                    optional: true
                },
                source: {
                    name: "source",
                    type: "String",
                    optional: true
                },
                rescheduled: {
                    name: "rescheduled",
                    type: "Boolean",
                    optional: true
                }
            }
        },
        GoogleCalendarEventsResult: {
            name: "GoogleCalendarEventsResult",
            fields: {
                events: {
                    name: "events",
                    type: "GoogleCalendarEvent",
                    array: true
                }
            }
        },
        RemoteContactApptInput: {
            name: "RemoteContactApptInput",
            fields: {
                phone: {
                    name: "phone",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        RemoteContactAppointment: {
            name: "RemoteContactAppointment",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                specialistName: {
                    name: "specialistName",
                    type: "String",
                    optional: true
                },
                patientName: {
                    name: "patientName",
                    type: "String",
                    optional: true
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                start: {
                    name: "start",
                    type: "String"
                },
                end: {
                    name: "end",
                    type: "String"
                },
                status: {
                    name: "status",
                    type: "String"
                },
                source: {
                    name: "source",
                    type: "String",
                    optional: true
                }
            }
        },
        RemoteContactApptResult: {
            name: "RemoteContactApptResult",
            fields: {
                appointments: {
                    name: "appointments",
                    type: "RemoteContactAppointment",
                    array: true
                }
            }
        },
        CalendarDayInput: {
            name: "CalendarDayInput",
            fields: {
                from: {
                    name: "from",
                    type: "String"
                },
                to: {
                    name: "to",
                    type: "String"
                }
            }
        },
        CalendarSpecialistDay: {
            name: "CalendarSpecialistDay",
            fields: {
                specialistId: {
                    name: "specialistId",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                slotMinutes: {
                    name: "slotMinutes",
                    type: "Int"
                },
                provider: {
                    name: "provider",
                    type: "String"
                },
                events: {
                    name: "events",
                    type: "GoogleCalendarEvent",
                    array: true
                }
            }
        },
        CalendarAllResult: {
            name: "CalendarAllResult",
            fields: {
                specialists: {
                    name: "specialists",
                    type: "CalendarSpecialistDay",
                    array: true
                }
            }
        },
        GoogleCalendarsInput: {
            name: "GoogleCalendarsInput",
            fields: {
                availabilitySourceId: {
                    name: "availabilitySourceId",
                    type: "String"
                }
            }
        },
        GoogleCalendarListItem: {
            name: "GoogleCalendarListItem",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                summary: {
                    name: "summary",
                    type: "String"
                },
                primary: {
                    name: "primary",
                    type: "Boolean"
                },
                accessRole: {
                    name: "accessRole",
                    type: "String"
                }
            }
        },
        GoogleCalendarsResult: {
            name: "GoogleCalendarsResult",
            fields: {
                calendars: {
                    name: "calendars",
                    type: "GoogleCalendarListItem",
                    array: true
                }
            }
        },
        ChangePasswordInput: {
            name: "ChangePasswordInput",
            fields: {
                userId: {
                    name: "userId",
                    type: "String"
                },
                newPassword: {
                    name: "newPassword",
                    type: "String"
                },
                currentPassword: {
                    name: "currentPassword",
                    type: "String",
                    optional: true
                }
            }
        },
        AttachCallContactInput: {
            name: "AttachCallContactInput",
            fields: {
                callId: {
                    name: "callId",
                    type: "String"
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true
                }
            }
        },
        MergeContactsInput: {
            name: "MergeContactsInput",
            fields: {
                sourceId: {
                    name: "sourceId",
                    type: "String"
                },
                targetId: {
                    name: "targetId",
                    type: "String"
                }
            }
        },
        SetContactSpecialistsInput: {
            name: "SetContactSpecialistsInput",
            fields: {
                contactId: {
                    name: "contactId",
                    type: "String"
                },
                specialistIds: {
                    name: "specialistIds",
                    type: "String",
                    array: true
                }
            }
        },
        CreateAppointmentInput: {
            name: "CreateAppointmentInput",
            fields: {
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true
                },
                patientName: {
                    name: "patientName",
                    type: "String",
                    optional: true
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String",
                    optional: true
                },
                specialistId: {
                    name: "specialistId",
                    type: "String"
                },
                startsAt: {
                    name: "startsAt",
                    type: "String"
                },
                durationMin: {
                    name: "durationMin",
                    type: "Int",
                    optional: true
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                note: {
                    name: "note",
                    type: "String",
                    optional: true
                }
            }
        },
        CancelAppointmentInput: {
            name: "CancelAppointmentInput",
            fields: {
                appointmentId: {
                    name: "appointmentId",
                    type: "String"
                },
                patientName: {
                    name: "patientName",
                    type: "String",
                    optional: true
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String",
                    optional: true
                },
                startsAt: {
                    name: "startsAt",
                    type: "String",
                    optional: true
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    optional: true
                }
            }
        },
        RescheduleAppointmentInput: {
            name: "RescheduleAppointmentInput",
            fields: {
                appointmentId: {
                    name: "appointmentId",
                    type: "String"
                },
                newStartsAt: {
                    name: "newStartsAt",
                    type: "String"
                },
                newSpecialistId: {
                    name: "newSpecialistId",
                    type: "String",
                    optional: true
                },
                fromSpecialistId: {
                    name: "fromSpecialistId",
                    type: "String",
                    optional: true
                },
                patientName: {
                    name: "patientName",
                    type: "String",
                    optional: true
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String",
                    optional: true
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                }
            }
        },
        AppointmentAddGuestInput: {
            name: "AppointmentAddGuestInput",
            fields: {
                appointmentId: {
                    name: "appointmentId",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                phone: {
                    name: "phone",
                    type: "String",
                    optional: true
                }
            }
        },
        AppointmentRemoveGuestInput: {
            name: "AppointmentRemoveGuestInput",
            fields: {
                appointmentId: {
                    name: "appointmentId",
                    type: "String"
                },
                index: {
                    name: "index",
                    type: "Int"
                }
            }
        },
        AgentIdInput: {
            name: "AgentIdInput",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                }
            }
        },
        AgentFaqInput: {
            name: "AgentFaqInput",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                faq: {
                    name: "faq",
                    type: "String"
                }
            }
        },
        AgentStat: {
            name: "AgentStat",
            fields: {
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                calls: {
                    name: "calls",
                    type: "Int"
                },
                durationSec: {
                    name: "durationSec",
                    type: "Int"
                },
                cost: {
                    name: "cost",
                    type: "Float"
                }
            }
        },
        AgentDashboardResult: {
            name: "AgentDashboardResult",
            fields: {
                totalAgents: {
                    name: "totalAgents",
                    type: "Int"
                },
                syncedAgents: {
                    name: "syncedAgents",
                    type: "Int"
                },
                totalCalls: {
                    name: "totalCalls",
                    type: "Int"
                },
                totalDurationSec: {
                    name: "totalDurationSec",
                    type: "Int"
                },
                totalCost: {
                    name: "totalCost",
                    type: "Float"
                },
                avgDurationSec: {
                    name: "avgDurationSec",
                    type: "Int"
                },
                windowDays: {
                    name: "windowDays",
                    type: "Int"
                },
                perAgent: {
                    name: "perAgent",
                    type: "AgentStat",
                    array: true
                }
            }
        },
        AgentCallsInput: {
            name: "AgentCallsInput",
            fields: {
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String"
                }
            }
        },
        AgentFetchInput: {
            name: "AgentFetchInput",
            fields: {
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String"
                }
            }
        },
        AgentCallRow: {
            name: "AgentCallRow",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                startedAt: {
                    name: "startedAt",
                    type: "String",
                    optional: true
                },
                endedAt: {
                    name: "endedAt",
                    type: "String",
                    optional: true
                },
                durationSec: {
                    name: "durationSec",
                    type: "Int"
                },
                cost: {
                    name: "cost",
                    type: "Float"
                },
                status: {
                    name: "status",
                    type: "String",
                    optional: true
                },
                endedReason: {
                    name: "endedReason",
                    type: "String",
                    optional: true
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true
                },
                transcript: {
                    name: "transcript",
                    type: "String",
                    optional: true
                },
                callerName: {
                    name: "callerName",
                    type: "String",
                    optional: true
                },
                callerPhone: {
                    name: "callerPhone",
                    type: "String",
                    optional: true
                }
            }
        },
        AgentCallsResult: {
            name: "AgentCallsResult",
            fields: {
                calls: {
                    name: "calls",
                    type: "AgentCallRow",
                    array: true
                },
                totalCalls: {
                    name: "totalCalls",
                    type: "Int"
                },
                totalDurationSec: {
                    name: "totalDurationSec",
                    type: "Int"
                },
                totalCost: {
                    name: "totalCost",
                    type: "Float"
                }
            }
        },
        InngestRunRow: {
            name: "InngestRunRow",
            fields: {
                runId: {
                    name: "runId",
                    type: "String"
                },
                functionName: {
                    name: "functionName",
                    type: "String",
                    optional: true
                },
                status: {
                    name: "status",
                    type: "String"
                },
                startedAt: {
                    name: "startedAt",
                    type: "String",
                    optional: true
                },
                endedAt: {
                    name: "endedAt",
                    type: "String",
                    optional: true
                },
                output: {
                    name: "output",
                    type: "String",
                    optional: true
                }
            }
        },
        InngestEventRow: {
            name: "InngestEventRow",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                receivedAt: {
                    name: "receivedAt",
                    type: "String",
                    optional: true
                },
                dataJson: {
                    name: "dataJson",
                    type: "String"
                },
                runs: {
                    name: "runs",
                    type: "InngestRunRow",
                    array: true
                }
            }
        },
        InngestActivityResult: {
            name: "InngestActivityResult",
            fields: {
                events: {
                    name: "events",
                    type: "InngestEventRow",
                    array: true
                },
                ok: {
                    name: "ok",
                    type: "Boolean"
                },
                error: {
                    name: "error",
                    type: "String",
                    optional: true
                }
            }
        },
        AssistantChatTurn: {
            name: "AssistantChatTurn",
            fields: {
                role: {
                    name: "role",
                    type: "String"
                },
                content: {
                    name: "content",
                    type: "String"
                }
            }
        },
        AssistantAskInput: {
            name: "AssistantAskInput",
            fields: {
                question: {
                    name: "question",
                    type: "String"
                },
                history: {
                    name: "history",
                    type: "AssistantChatTurn",
                    array: true
                },
                language: {
                    name: "language",
                    type: "String"
                },
                path: {
                    name: "path",
                    type: "String",
                    optional: true
                }
            }
        },
        GroupEventIdInput: {
            name: "GroupEventIdInput",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                }
            }
        },
        GroupEventEnrollInput: {
            name: "GroupEventEnrollInput",
            fields: {
                slotId: {
                    name: "slotId",
                    type: "String"
                },
                patientName: {
                    name: "patientName",
                    type: "String"
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String"
                },
                assignedUserId: {
                    name: "assignedUserId",
                    type: "String",
                    optional: true
                },
                serviceId: {
                    name: "serviceId",
                    type: "String",
                    optional: true
                },
                arrivalTime: {
                    name: "arrivalTime",
                    type: "String",
                    optional: true
                },
                overbook: {
                    name: "overbook",
                    type: "Boolean",
                    optional: true
                }
            }
        },
        GroupEventEnrollmentIdInput: {
            name: "GroupEventEnrollmentIdInput",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                }
            }
        },
        AdminImportInput: {
            name: "AdminImportInput",
            fields: {
                json: {
                    name: "json",
                    type: "String"
                }
            }
        },
        AdminResetDataInput: {
            name: "AdminResetDataInput",
            fields: {
                kind: {
                    name: "kind",
                    type: "String"
                }
            }
        }
    } as const;
    enums = {
        Role: {
            name: "Role",
            values: {
                USER: "USER",
                ADMIN: "ADMIN",
                SPECIALIST: "SPECIALIST",
                SUPERDOC: "SUPERDOC"
            }
        },
        AvailabilityProvider: {
            name: "AvailabilityProvider",
            values: {
                GOOGLE_CALENDAR: "GOOGLE_CALENDAR",
                LOCAL: "LOCAL",
                GROUP_EVENT: "GROUP_EVENT",
                SUPERDOC: "SUPERDOC"
            }
        },
        EnrollmentStatus: {
            name: "EnrollmentStatus",
            values: {
                ENROLLED: "ENROLLED",
                CANCELLED: "CANCELLED"
            }
        },
        AppointmentStatus: {
            name: "AppointmentStatus",
            values: {
                BOOKED: "BOOKED",
                CANCELLED: "CANCELLED"
            }
        },
        CallBookingAction: {
            name: "CallBookingAction",
            values: {
                BOOKED: "BOOKED",
                RESCHEDULED: "RESCHEDULED",
                CANCELLED: "CANCELLED"
            }
        },
        ActivityAction: {
            name: "ActivityAction",
            values: {
                BOOKED: "BOOKED",
                RESCHEDULED: "RESCHEDULED",
                CANCELLED: "CANCELLED",
                LATE: "LATE",
                OTHER: "OTHER"
            }
        },
        ActivityPlatform: {
            name: "ActivityPlatform",
            values: {
                WEB: "WEB",
                PHONE: "PHONE",
                SUPERDOC: "SUPERDOC"
            }
        },
        ContactStatus: {
            name: "ContactStatus",
            values: {
                LEAD: "LEAD",
                ACTIVE: "ACTIVE",
                INACTIVE: "INACTIVE"
            }
        }
    } as const;
    authType = "Auth" as const;
    procedures = {
        signUp: {
            params: {
                input: { name: "input", type: "SignUpInput" }
            },
            returnType: "String",
            mutation: true
        },
        login: {
            params: {
                input: { name: "input", type: "LoginInput" }
            },
            returnType: "String",
            mutation: true
        },
        me: {
            params: {},
            returnType: "User"
        },
        markNotificationsSeen: {
            params: {},
            returnType: "User",
            mutation: true
        },
        deactivateAccount: {
            params: {},
            returnType: "User",
            mutation: true
        },
        findSpecialists: {
            params: {
                input: { name: "input", type: "FindSpecialistsInput" }
            },
            returnType: "Specialist",
            returnArray: true
        },
        adminInviteUser: {
            params: {
                input: { name: "input", type: "AdminInviteUserInput" }
            },
            returnType: "Invite",
            mutation: true
        },
        adminCreateUser: {
            params: {
                input: { name: "input", type: "AdminCreateUserInput" }
            },
            returnType: "User",
            mutation: true
        },
        changePassword: {
            params: {
                input: { name: "input", type: "ChangePasswordInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        googleCalendarConnect: {
            params: {
                input: { name: "input", type: "GoogleCalendarConnectInput" }
            },
            returnType: "GoogleCalendarConnectResult",
            mutation: true
        },
        googleCalendarDisconnect: {
            params: {
                input: { name: "input", type: "GoogleCalendarDisconnectInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        googleCalendarEvents: {
            params: {
                input: { name: "input", type: "GoogleCalendarEventsInput" }
            },
            returnType: "GoogleCalendarEventsResult"
        },
        localCalendarPreview: {
            params: {
                input: { name: "input", type: "GoogleCalendarEventsInput" }
            },
            returnType: "GoogleCalendarEventsResult"
        },
        localCalendarPreviewAll: {
            params: {
                input: { name: "input", type: "CalendarDayInput" }
            },
            returnType: "CalendarAllResult"
        },
        remoteContactAppointments: {
            params: {
                input: { name: "input", type: "RemoteContactApptInput" }
            },
            returnType: "RemoteContactApptResult"
        },
        googleCalendars: {
            params: {
                input: { name: "input", type: "GoogleCalendarsInput" }
            },
            returnType: "GoogleCalendarsResult"
        },
        acceptInvite: {
            params: {
                input: { name: "input", type: "AcceptInviteInput" }
            },
            returnType: "String",
            mutation: true
        },
        checkInvite: {
            params: {
                input: { name: "input", type: "CheckInviteInput" }
            },
            returnType: "CheckInviteResult",
            mutation: true
        },
        agentLink: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentUpdate: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentDelete: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentUnlink: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentFetch: {
            params: {
                input: { name: "input", type: "AgentFetchInput" }
            },
            returnType: "String",
            mutation: true
        },
        agentSyncSpecialists: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentDeployFaq: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentSaveFaq: {
            params: {
                input: { name: "input", type: "AgentFaqInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentDashboard: {
            params: {},
            returnType: "AgentDashboardResult"
        },
        agentCalls: {
            params: {
                input: { name: "input", type: "AgentCallsInput" }
            },
            returnType: "AgentCallsResult"
        },
        agentSpecialistRoster: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "String"
        },
        agentSyncKnowledgeDoc: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "AgentKnowledgeDoc",
            mutation: true
        },
        agentDeleteKnowledgeDoc: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "AgentKnowledgeDoc",
            mutation: true
        },
        attachCallContact: {
            params: {
                input: { name: "input", type: "AttachCallContactInput" }
            },
            returnType: "Call",
            mutation: true
        },
        mergeContacts: {
            params: {
                input: { name: "input", type: "MergeContactsInput" }
            },
            returnType: "Contact",
            mutation: true
        },
        setContactSpecialists: {
            params: {
                input: { name: "input", type: "SetContactSpecialistsInput" }
            },
            returnType: "Contact",
            mutation: true
        },
        createAppointment: {
            params: {
                input: { name: "input", type: "CreateAppointmentInput" }
            },
            returnType: "Appointment",
            mutation: true
        },
        cancelAppointment: {
            params: {
                input: { name: "input", type: "CancelAppointmentInput" }
            },
            returnType: "Appointment",
            mutation: true
        },
        rescheduleAppointment: {
            params: {
                input: { name: "input", type: "RescheduleAppointmentInput" }
            },
            returnType: "Appointment",
            mutation: true
        },
        appointmentAddGuest: {
            params: {
                input: { name: "input", type: "AppointmentAddGuestInput" }
            },
            returnType: "Appointment",
            mutation: true
        },
        appointmentRemoveGuest: {
            params: {
                input: { name: "input", type: "AppointmentRemoveGuestInput" }
            },
            returnType: "Appointment",
            mutation: true
        },
        inngestActivity: {
            params: {},
            returnType: "InngestActivityResult"
        },
        assistantAsk: {
            params: {
                input: { name: "input", type: "AssistantAskInput" }
            },
            returnType: "String",
            mutation: true
        },
        groupEventMembers: {
            params: {
                input: { name: "input", type: "GroupEventIdInput" }
            },
            returnType: "String"
        },
        groupEventEnroll: {
            params: {
                input: { name: "input", type: "GroupEventEnrollInput" }
            },
            returnType: "String",
            mutation: true
        },
        groupEventCancelEnrollment: {
            params: {
                input: { name: "input", type: "GroupEventEnrollmentIdInput" }
            },
            returnType: "String",
            mutation: true
        },
        adminExportGroupEvents: {
            params: {},
            returnType: "String"
        },
        adminImportGroupEvents: {
            params: {
                input: { name: "input", type: "AdminImportInput" }
            },
            returnType: "String",
            mutation: true
        },
        adminExportAppointments: {
            params: {},
            returnType: "String"
        },
        adminImportAppointments: {
            params: {
                input: { name: "input", type: "AdminImportInput" }
            },
            returnType: "String",
            mutation: true
        },
        adminResetData: {
            params: {
                input: { name: "input", type: "AdminResetDataInput" }
            },
            returnType: "Int",
            mutation: true
        }
    } as const;
    plugins = {};
}
export const schema = new SchemaType();
